import { Avatar, AvatarProps } from '@mui/material';
import { stringAvatarProps } from './string-avatar.utils';

type StringAvatarProps = {
  name: string;
  showBgColor?: boolean;
  sx?: any;
} & AvatarProps;

const StringAvatar = ({
  name,
  showBgColor = true,
  sx,
  ...rest
}: StringAvatarProps) => {
  if (!name) return null;

  return <Avatar {...stringAvatarProps(name, showBgColor, sx, rest)} />;
};

export default StringAvatar;
